// Portal strings (English / Arabic). Keys are dotted paths.
export const messages = {
	en: {
		nav: {
			home: "Home", dashboard: "Dashboard", tickets: "Tickets", conversations: "Messages", knowledge: "Knowledge base",
			services: "Services", account: "Orders & invoices", settings: "Settings", logout: "Log out",
			agent: "Agent workspace", notifications: "Notifications", organization: "Organization",
		},
		common: {
			loading: "Loading…", retry: "Try again", save: "Save", saved: "Saved", cancel: "Cancel", send: "Send",
			submit: "Submit", search: "Search", back: "Back", attach: "Attach files", none: "Nothing here yet",
			view_all: "View all", download: "Download", close: "Close", markAllRead: "Mark all read",
			yes: "Yes", no: "No", optional: "optional", of: "of", total: "Total", status: "Status", date: "Date",
		},
		errors: {
			network: "Can't reach the server. Check your connection and try again.",
			forbidden: "You don't have access to this.", generic: "Something went wrong. Please try again.",
			unlinked: "Your account isn't linked to an organization yet",
			unlinked_help: "Ask your company administrator or our support team to grant you portal access.",
			not_found: "Page not found",
		},
		dash: {
			welcome: "Welcome back", open: "Open", waiting: "Awaiting you", resolved: "Resolved", overdue: "Overdue",
			unread: "Unread messages", outstanding: "Outstanding balance", recent_tickets: "Recent tickets",
			recent_messages: "Recent conversations", articles: "Helpful articles", quick: "Quick actions",
			new_ticket: "Raise a ticket", new_message: "Message support", browse_services: "Request a service",
			requests: "Your service requests",
		},
		tickets: {
			title: "Support tickets", new: "New ticket", mine: "My tickets", org: "Organization",
			all: "All", open: "Open", waiting: "Awaiting you", resolved: "Resolved", subject: "Subject",
			description: "Describe the issue", type: "Category", priority: "Priority", create: "Submit ticket",
			suggested: "These articles may answer your question", reply: "Write a reply…", send_reply: "Send reply",
			timeline: "Conversation", sla_response: "First response by", sla_resolution: "Resolution by",
			team: "Team", reopen: "Reopen ticket", rate: "Rate this resolution", rate_comment: "Anything to add?",
			thanks: "Thanks for your feedback", created: "Ticket created", attachments: "Attachments",
			unavailable: "Ticketing is temporarily unavailable.", you: "You", overdue: "Overdue",
			search_ph: "Search by subject or number",
		},
		conv: {
			title: "Messages", new: "New conversation", subject: "Topic", message: "Message", start: "Start conversation",
			type_message: "Type a message…", escalate: "Convert to ticket", escalated: "Linked to ticket",
			share_org: "Visible to my organization's managers", closed: "This conversation is closed.",
			close: "Close conversation", empty: "Select a conversation", provider_raven: "Connected to the support team",
		},
		kb: { title: "Knowledge base", search: "Search articles", categories: "Categories", all: "All articles",
			not_helpful: "Still need help?", raise: "Raise a ticket", browse: "Browse articles", filter: "Filter by title",
			no_match: "No articles match.", updated: "Updated", copy_link: "Copy link", copied: "Link copied",
			helpful_q: "Was this article helpful?", yes: "Yes", no: "No", thanks: "Thanks for your feedback.",
			what_missing: "What was missing or unclear? (optional)", send: "Send", thanks_comment: "Thanks, we'll use this to improve the article.",
			not_resolved: "If your issue isn't resolved, raise a support ticket here.", raise_here: "Raise a support ticket",
			login_raise: "Log in to raise a ticket", chat: "Chat with us", related: "Related articles",
			ticket_about: "About help article:" },
		services: {
			title: "Services", catalogue: "Service catalogue", request: "Request", my_requests: "My requests",
			subscriptions: "Subscriptions & licences", details: "Details", related: "Related document",
			priority: "Priority", submitted: "Request submitted", response: "Response from support",
			plans: "Plans", ends: "Ends",
		},
		account: {
			title: "Orders & invoices", orders: "Orders", invoices: "Invoices", statement: "Statement",
			documents: "Documents", outstanding: "Outstanding", overdue: "Overdue", due: "Due",
			delivered: "Delivered", billed: "Billed", pdf: "Download PDF", query: "Ask about this",
			payments: "Recent payments", items: "Items", qty: "Qty", rate: "Rate", amount: "Amount", tax: "Tax",
			only_outstanding: "Outstanding only", remaining: "downloads left",
		},
		settings: {
			title: "Settings", profile: "Profile", language: "Language", timezone: "Time zone",
			default_org: "Default organization", theme: "Appearance", notifications: "Notifications",
			email_ticket_updates: "Email me when a ticket status changes",
			portal_ticket_updates: "Show ticket and request updates in the portal",
			email_message_alerts: "Email me when support replies to a message",
			portal_message_alerts: "Show message alerts in the portal",
			email_request_updates: "Email me about service request updates",
			email_invoice_alerts: "Email me about new invoices",
			members: "Organization members", request_member: "Request access for a colleague",
			member_email: "Email", member_name: "Full name", member_level: "Access level",
			member_requested: "Request sent to the administrator",
		},
		admin: { warnings: "Administrator notices", settings: "Open portal settings" },
		land: {
			hero: "How can we help you today?", search_ph: "Search help articles, e.g. VAT return", search: "Search",
			actions: "Get help", articles: "Popular articles", categories: "Browse by topic", services: "Our services",
			faq: "Frequently asked questions", contact: "Contact and support hours", summary: "Your account",
			email: "Email", phone: "Phone", hours: "Support hours", online: "We're online now", offline: "We're offline now",
			chat_now: "Chat now", whatsapp: "WhatsApp", login: "Log in", logout: "Log out", login_hint: "Log in required",
			request: "Request", view_all: "View all", open_tickets: "Open tickets", waiting: "Awaiting your reply",
			unread: "Unread messages", outstanding: "Outstanding", go_dashboard: "Go to dashboard",
			unlinked: "Your account isn't linked to a customer yet. You can browse help and chat with us; ask your company administrator for portal access.",
			menu: "Menu", language: "العربية", dashboard: "Dashboard", home: "Home",
			days: { Mon: "Mon", Tue: "Tue", Wed: "Wed", Thu: "Thu", Fri: "Fri", Sat: "Sat", Sun: "Sun" },
			qa: {
				ticket: ["Raise a ticket", "Report a problem and track it to resolution"],
				chat: ["Chat with us", "Talk to our assistant or a member of the team"],
				knowledge: ["Help articles", "Guides and answers to common questions"],
				my_tickets: ["My tickets", "Follow up on your open requests"],
				orders: ["Orders and invoices", "Delivery status, invoices and statements"],
				services: ["Request a service", "Training, data imports, changes and more"],
				whatsapp: ["WhatsApp us", "Message our support number"],
				contact: ["Contact us", "Email and phone details"],
			},
		},
	},
	ar: {
		nav: {
			home: "الرئيسية", dashboard: "لوحة التحكم", tickets: "التذاكر", conversations: "الرسائل", knowledge: "قاعدة المعرفة",
			services: "الخدمات", account: "الطلبات والفواتير", settings: "الإعدادات", logout: "تسجيل الخروج",
			agent: "مساحة عمل الوكيل", notifications: "الإشعارات", organization: "الجهة",
		},
		common: {
			loading: "جارٍ التحميل…", retry: "إعادة المحاولة", save: "حفظ", saved: "تم الحفظ", cancel: "إلغاء",
			send: "إرسال", submit: "إرسال", search: "بحث", back: "رجوع", attach: "إرفاق ملفات", none: "لا يوجد شيء بعد",
			view_all: "عرض الكل", download: "تنزيل", close: "إغلاق", markAllRead: "تعليم الكل كمقروء",
			yes: "نعم", no: "لا", optional: "اختياري", of: "من", total: "الإجمالي", status: "الحالة", date: "التاريخ",
		},
		errors: {
			network: "تعذر الاتصال بالخادم. تحقق من الاتصال وحاول مرة أخرى.", forbidden: "ليست لديك صلاحية الوصول.",
			generic: "حدث خطأ ما. يرجى المحاولة مرة أخرى.", unlinked: "حسابك غير مرتبط بأي جهة بعد",
			unlinked_help: "اطلب من مسؤول شركتك أو فريق الدعم منحك صلاحية الدخول إلى البوابة.",
			not_found: "الصفحة غير موجودة",
		},
		dash: {
			welcome: "مرحباً بعودتك", open: "مفتوحة", waiting: "بانتظار ردك", resolved: "محلولة", overdue: "متأخرة",
			unread: "رسائل غير مقروءة", outstanding: "الرصيد المستحق", recent_tickets: "أحدث التذاكر",
			recent_messages: "أحدث المحادثات", articles: "مقالات مفيدة", quick: "إجراءات سريعة",
			new_ticket: "فتح تذكرة", new_message: "مراسلة الدعم", browse_services: "طلب خدمة", requests: "طلبات الخدمة",
		},
		tickets: {
			title: "تذاكر الدعم", new: "تذكرة جديدة", mine: "تذاكري", org: "الجهة", all: "الكل", open: "مفتوحة",
			waiting: "بانتظار ردك", resolved: "محلولة", subject: "الموضوع", description: "صف المشكلة",
			type: "الفئة", priority: "الأولوية", create: "إرسال التذكرة", suggested: "قد تجيب هذه المقالات عن سؤالك",
			reply: "اكتب رداً…", send_reply: "إرسال الرد", timeline: "المحادثة", sla_response: "الرد الأول قبل",
			sla_resolution: "الحل قبل", team: "الفريق", reopen: "إعادة فتح التذكرة", rate: "قيّم الحل",
			rate_comment: "هل لديك ما تضيفه؟", thanks: "شكراً على ملاحظاتك", created: "تم إنشاء التذكرة",
			attachments: "المرفقات", unavailable: "نظام التذاكر غير متاح مؤقتاً.", you: "أنت", overdue: "متأخرة",
			search_ph: "ابحث بالموضوع أو الرقم",
		},
		conv: {
			title: "الرسائل", new: "محادثة جديدة", subject: "الموضوع", message: "الرسالة", start: "بدء المحادثة",
			type_message: "اكتب رسالة…", escalate: "تحويل إلى تذكرة", escalated: "مرتبطة بالتذكرة",
			share_org: "مرئية لمديري جهتي", closed: "هذه المحادثة مغلقة.", close: "إغلاق المحادثة",
			empty: "اختر محادثة", provider_raven: "متصلة بفريق الدعم",
		},
		kb: { title: "قاعدة المعرفة", search: "ابحث في المقالات", categories: "التصنيفات", all: "كل المقالات",
			not_helpful: "هل ما زلت بحاجة إلى مساعدة؟", raise: "فتح تذكرة", browse: "تصفح المقالات", filter: "تصفية حسب العنوان",
			no_match: "لا توجد مقالات مطابقة.", updated: "آخر تحديث", copy_link: "نسخ الرابط", copied: "تم نسخ الرابط",
			helpful_q: "هل كانت هذه المقالة مفيدة؟", yes: "نعم", no: "لا", thanks: "شكرًا على ملاحظاتك.",
			what_missing: "ما الذي كان ناقصًا أو غير واضح؟ (اختياري)", send: "إرسال", thanks_comment: "شكرًا، سنستخدم ملاحظتك لتحسين المقالة.",
			not_resolved: "إذا لم تُحل مشكلتك، افتح تذكرة دعم من هنا.", raise_here: "فتح تذكرة دعم",
			login_raise: "سجّل الدخول لفتح تذكرة", chat: "تحدث معنا", related: "مقالات ذات صلة",
			ticket_about: "بخصوص مقالة المساعدة:" },
		services: {
			title: "الخدمات", catalogue: "دليل الخدمات", request: "طلب", my_requests: "طلباتي",
			subscriptions: "الاشتراكات والتراخيص", details: "التفاصيل", related: "مستند مرتبط", priority: "الأولوية",
			submitted: "تم إرسال الطلب", response: "رد فريق الدعم", plans: "الخطط", ends: "ينتهي",
		},
		account: {
			title: "الطلبات والفواتير", orders: "الطلبات", invoices: "الفواتير", statement: "كشف الحساب",
			documents: "المستندات", outstanding: "المستحق", overdue: "متأخر", due: "تاريخ الاستحقاق",
			delivered: "تم التسليم", billed: "تمت الفوترة", pdf: "تنزيل PDF", query: "استفسار بخصوص هذا",
			payments: "آخر المدفوعات", items: "الأصناف", qty: "الكمية", rate: "السعر", amount: "المبلغ", tax: "الضريبة",
			only_outstanding: "المستحقة فقط", remaining: "تنزيلات متبقية",
		},
		settings: {
			title: "الإعدادات", profile: "الملف الشخصي", language: "اللغة", timezone: "المنطقة الزمنية",
			default_org: "الجهة الافتراضية", theme: "المظهر", notifications: "الإشعارات",
			email_ticket_updates: "راسلني عند تغيّر حالة التذكرة",
			portal_ticket_updates: "اعرض تحديثات التذاكر والطلبات في البوابة",
			email_message_alerts: "راسلني عند رد الدعم على رسالة",
			portal_message_alerts: "اعرض تنبيهات الرسائل في البوابة",
			email_request_updates: "راسلني بتحديثات طلبات الخدمة",
			email_invoice_alerts: "راسلني عند صدور فواتير جديدة",
			members: "أعضاء الجهة", request_member: "طلب صلاحية لزميل", member_email: "البريد الإلكتروني",
			member_name: "الاسم الكامل", member_level: "مستوى الصلاحية", member_requested: "تم إرسال الطلب إلى المسؤول",
		},
		admin: { warnings: "تنبيهات المسؤول", settings: "فتح إعدادات البوابة" },
		land: {
			hero: "كيف يمكننا مساعدتك اليوم؟", search_ph: "ابحث في مقالات المساعدة، مثلاً إقرار الضريبة", search: "بحث",
			actions: "احصل على المساعدة", articles: "المقالات الأكثر قراءة", categories: "تصفح حسب الموضوع", services: "خدماتنا",
			faq: "الأسئلة الشائعة", contact: "التواصل وساعات الدعم", summary: "حسابك",
			email: "البريد الإلكتروني", phone: "الهاتف", hours: "ساعات الدعم", online: "نحن متصلون الآن", offline: "نحن غير متصلين الآن",
			chat_now: "تحدث الآن", whatsapp: "واتساب", login: "تسجيل الدخول", logout: "تسجيل الخروج", login_hint: "يتطلب تسجيل الدخول",
			request: "طلب", view_all: "عرض الكل", open_tickets: "تذاكر مفتوحة", waiting: "بانتظار ردك",
			unread: "رسائل غير مقروءة", outstanding: "المستحق", go_dashboard: "الذهاب إلى لوحة التحكم",
			unlinked: "حسابك غير مرتبط بعميل بعد. يمكنك تصفح المساعدة والتحدث معنا، واطلب من مسؤول شركتك صلاحية البوابة.",
			menu: "القائمة", language: "English", dashboard: "لوحة التحكم", home: "الرئيسية",
			days: { Mon: "الإثنين", Tue: "الثلاثاء", Wed: "الأربعاء", Thu: "الخميس", Fri: "الجمعة", Sat: "السبت", Sun: "الأحد" },
			qa: {
				ticket: ["فتح تذكرة", "أبلغ عن مشكلة وتابعها حتى الحل"],
				chat: ["تحدث معنا", "تحدث مع المساعد أو أحد أعضاء الفريق"],
				knowledge: ["مقالات المساعدة", "أدلة وإجابات للأسئلة الشائعة"],
				my_tickets: ["تذاكري", "تابع طلباتك المفتوحة"],
				orders: ["الطلبات والفواتير", "حالة التسليم والفواتير وكشوف الحساب"],
				services: ["طلب خدمة", "تدريب واستيراد بيانات وتعديلات وغيرها"],
				whatsapp: ["راسلنا عبر واتساب", "أرسل رسالة إلى رقم الدعم"],
				contact: ["اتصل بنا", "البريد الإلكتروني والهاتف"],
			},
		},
	},
};

export function translate(lang, key, vars) {
	const pick = (dict) => key.split(".").reduce((o, k) => (o && o[k] !== undefined ? o[k] : undefined), dict);
	let s = pick(messages[lang] || messages.en);
	if (s === undefined) s = pick(messages.en);
	if (s === undefined) s = key;
	if (vars) Object.entries(vars).forEach(([k, v]) => (s = s.replace(`{${k}}`, v)));
	return s;
}
